export default __webpack_public_path__ + "static/media/logo.d4a58c06.png";